import { SettingsContext } from '@internal/page/SettingsContext';
import { TLocale } from '@internal/utils/machine/i18n/Locale';
import { CallOutlined, Close } from '@mui/icons-material';
import { ClickToCopyWrapper } from '@renderer-ui-library/molecules';
import { Paper, Slide, Typography } from '@renderer-ui-library/mui';
import classNames from 'classnames';
import Link from 'next/link';
import React, { SyntheticEvent, useContext } from 'react';
import styles from './machineDetailsContact.module.scss';

export interface ContactPhoneSlideProps {
    open: boolean;
    locale: TLocale;
    onClose: (e: SyntheticEvent) => void;
    container?: Element | null;
}

export const ContactPhoneSlide: React.FC<ContactPhoneSlideProps> = React.memo(
    ({ open, onClose, container, locale }) => {
        const { customerServiceNumbers } = useContext(SettingsContext);
        const serviceNumber = customerServiceNumbers[locale];
        return (
            <div
                className={classNames({
                    [styles.slide]: true,
                    [styles.container]: container,
                })}
            >
                <Slide
                    direction="up"
                    in={open}
                    mountOnEnter
                    unmountOnExit
                    container={container}
                >
                    <Paper elevation={4} className={styles.paper}>
                        <div className={styles.slideContent}>
                            <ClickToCopyWrapper
                                text={serviceNumber?.linkNumber ?? ''}
                            >
                                <div className={styles.phoneContent}>
                                    <CallOutlined className={styles.icon} />
                                    {serviceNumber && (
                                        <Typography variant="body1">
                                            <Link
                                                href={`tel:${serviceNumber.linkNumber}`}
                                            >
                                                {serviceNumber.displayNumber}
                                            </Link>
                                        </Typography>
                                    )}
                                </div>
                            </ClickToCopyWrapper>

                            <Close
                                onClick={onClose}
                                className={styles.clickable}
                            />
                        </div>
                    </Paper>
                </Slide>
            </div>
        );
    },
);

ContactPhoneSlide.displayName = 'ContactPhoneSlide';
